export const NETWORK_ERROR = 'dynamic-list/bootstrap/NETWORK_ERROR'

export const BOOTSTRAP = 'dynamic-list/bootstrap/BOOTSTRAP'
export const BOOTSTRAPPED = 'dynamic-list/bootstrap/BOOTSTRAPPED'



// WEBPACK FOOTER //
// ./src/dynamic-list/redux/modules/bootstrap/types.js